import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

type SerialKeyboardCallbacks = {
  onKey: (k: string) => void;
  onBackspace: () => void;
};

export const useSerialKeyboard = defineStore('serial-keyboard', () => {
  const focusedInputId = ref<string>();
  const isOpen = computed(() => !!focusedInputId.value);
  let callbacks: SerialKeyboardCallbacks | null = null;

  function keyPressed(k: string) {
    if (focusedInputId.value) {
      document
        .getElementById(focusedInputId.value)
        ?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' });
    }
    callbacks?.onKey(k);
  }

  function backspace() {
    if (focusedInputId.value) {
      document
        .getElementById(focusedInputId.value)
        ?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' });
    }
    callbacks?.onBackspace();
  }

  function setFocus(id: string, cbs: SerialKeyboardCallbacks) {
    focusedInputId.value = id;
    setTimeout(() => {
      if (focusedInputId.value === id) {
        document
          .getElementById(focusedInputId.value)
          ?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' });
      }
    }, 300);
    callbacks = cbs;
  }

  function close() {
    focusedInputId.value = undefined;
    callbacks = null;
  }

  function isInputFocused(id: string) {
    return focusedInputId.value === id;
  }

  return {
    isOpen,
    setFocus,
    close,
    keyPressed,
    backspace,
    isInputFocused,
  };
});
